import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../@types/RootState';

const initialState = 0;

const slice = createSlice({
  name: 'getFamilyClusterModal/totalElements',
  initialState,
  reducers: {
    SET_GET_FAMILY_CLUSTER_MODAL_TOTAL_ELEMENTS: (_state, { payload }: PayloadAction<number>) => payload,
  },
});

export const selectorGetFamilyClusterModalTotalElements = (state: RootState) => {
  return state.getFamilyClusterModalReducer.totalElements;
};

export const { SET_GET_FAMILY_CLUSTER_MODAL_TOTAL_ELEMENTS } = slice.actions;

export default slice.reducer;
